import { humanize } from "../ra-lb-tools/utils/tools";

export const formatLockerStatusName = (st, verbose) => {
  if (st.name.includes("(")) {
    return st.name;
  }

  let name = humanize(st.name);

  if (verbose) {
    const assignable_label = st.isAssignable ? "assignable" : "non assignable";
    name += ` (${assignable_label})`;
  }

  return name;
};

export const formatLockerStatus = (st, verbose) => {
  return { ...st, name: formatLockerStatusName(st, verbose) };
};
